import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { useLanguage } from "../i18n/LanguageContext";

const About = () => {
  const { t } = useLanguage();

  return (
    <>
      <NavBar />
      <main className="min-h-screen bg-gray-50 pt-28 pb-16 px-6">
        <div className="container mx-auto max-w-3xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">
            {t("about.title")}
          </h1>
          <p className="text-lg font-semibold text-gray-500 mb-8">
            {t("hero.tagline")}
          </p>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
            <p>{t("about.p3")}</p>
            <p>{t("about.p4")}</p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default About;
